<script setup lang="ts">
import { useDivisibleReceiver } from '@precon-tools-suite-by-shared/vue-divisibles';
import { usePartialComponent } from '@precon-tools-suite-by-shared/vue-partials';
import type { Component } from 'vue';

const props = withDefaults(
    defineProps<{
        partial: Component | string;
        fallbackPartial?: Component | string | null;
        partialProps?: Record<string, unknown>;
    }>(),
    {
        fallbackPartial: null,
        partialProps: () => ({}),
    }
);

useDivisibleReceiver();
const partialComponent = usePartialComponent(() => props.partial, {
    fallback: () => props.fallbackPartial,
});
</script>

<template>
    <component :is="partialComponent" v-bind="partialProps">
        <slot />
    </component>
</template>
